var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diligence"},[_c('van-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"我的绩效"}},[_c('Target',{attrs:{"createdate":_vm.createdate}})],1),(_vm.leader !== 0)?_c('van-tab',{attrs:{"title":"团队绩效"}},[_c('Result')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }